import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-insight-coaching-warning-box',
    template: `
        <div class="cmps-insight-coaching-warning-box--container">
            <cmps-icon svgIcon="__internal:folder-heart"></cmps-icon>
            <span class="cmps-insight-coaching-warning-box--label">
                {{ number }} {{ label }}
            </span>
        </div>
    `,
    host: {
        class: 'cmps-insight-coaching-warning-box',
    },
})
export class CmpsInsightCoachingWarningBoxComponent {
    @Input() number: string;
    @Input() label: string;
}
